import toString from 'lodash/toString';

import { RenewalDeductibleConfig, RenewalProcessingTier } from '@/modules/Renewals/renewals.types';

export const getTierTriggerNames = (
  tier: RenewalProcessingTier,
  deductibleConfigs?: RenewalDeductibleConfig[]
): string[] => {
  const triggerIds = tier.tierTriggerIds || [];
  if (!triggerIds.length) return [];

  const names: string[] = [];

  triggerIds.forEach((id) => {
    if (!id) return;
    (deductibleConfigs || []).forEach((config) => {
      (config.triggerConfigs || []).forEach((triggerConfig) => {
        if (
          toString(triggerConfig.triggerId) === toString(id) &&
          triggerConfig.triggerName &&
          !names.includes(triggerConfig.triggerName)
        ) {
          names.push(triggerConfig.triggerName);
        }
      });
    });
  });

  return names;
};
